/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["ca-photo-picker[_ngcontent-%COMP%]{display:block;position:relative}ca-photo-picker.icon[_ngcontent-%COMP%]{width:100px;height:100px;margin-bottom:20px}ca-photo-picker.memoLogo[_ngcontent-%COMP%]{width:300px;height:300px}ca-photo-picker.background[_ngcontent-%COMP%]{width:100%;height:350px;margin-bottom:20px}"];
export { styles as styles };
